import React, { useEffect } from "react";
import { Box, Container, Grid2 as Grid, Typography, Link } from "@mui/material";
import { motion } from "framer-motion";
import MosaicPlaceholder from "../components/MosaicPlaceholder";
import theme from "../styles/theme";

const ResourcesPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const resources = [
    {
      title: "Please Report Suspicious Items or Activity",
      content:
        "You can be an extra set of eyes and ears while in or around our stations, trains, and facilities by using the Amtrak easy and discreet txt-a-tip program. Remember, If You See Something, Say Something.",
      actionText: "txt-a-tip to APD11 (27311)",
      image: "/images/resourcepage/txtatip.jpg",
      imagePosition: "right",
    },
    // {
    //   title: "Join Our Neighborhood Watch Program",
    //   content: "You can assist the APD by becoming a Partners for Amtrak Safety and Security (PASS) member. Community member's eyes and ears extend the reach of APD near terminals, along the railroad tracks, in stations, and onboard trains. Your commitment helps maintain a safe and secure rail network by being watchful, observant, and reporting any suspicious persons or suspicious or unusual activities to APD.",
    //   actionText: "Become a PASS member",
    //   link: "https://pass.amtrak.com",
    //   image: "/images/Pass pic.jpg",
    //   imagePosition: "left",
    // },
    {
      title: "Operation Lifesaver",
      content:
        "Operation Lifesaver, Inc. (OLI) is a non-profit organization and nationally-recognized leader of rail safety education. Since 1972, OLI has been committed to preventing collisions, injuries, and fatalities on and around railroad tracks and highway-rail grade crossings, with the support of public education programs in states across the U.S.",
      image: "/images/resourcepage/ols-logo.png",
      imagePosition: "right",
      link: "https://oli.org",
    },
    {
      title: "Amtrak Police Department",
      content:
        "The Amtrak Police Department is a fully accredited national police force responsible for ensuring the safety and security of over 30 million customers traveling on 21,400 miles of routes to more than 500 destinations in 46 states, the District of Columbia, and three Canadian provinces. Our more than 500 sworn and civilian personnel located at more than 30 locations in 46 states conduct a range of behind-the-scenes and front-line security measures to ensure Amtrak employee, customer, and infrastructure safety and security.",
      link: "https://amtrak.com/police/home",
      image: "/images/Amtrak Motion Logo.png",
      imagePosition: "left",
    },
  ];

  return (
    <Container maxWidth="lg">
      <MosaicPlaceholder />
      <Box className="space-y-6">
        {resources.map((resource, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <Box
              sx={{
                position: "relative",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: index % 2 === 0 ? "#e7e7e8" : "transparent",
                  zIndex: -1,
                },
              }}
            >
              <Grid
                container
                spacing={3}
                sx={{
                  display: "flex",
                  justifyContext: "center",
                  minHeight: "250px",
                  flexDirection:
                    resource.imagePosition === "left" ? "row" : "row-reverse",
                }}
              >
                <Grid size={{ xs: 12, md: 6 }}>
                  <motion.div
                    whileHover={{ scale: 1.0 }}
                    transition={{ duration: 0.3 }}
                    style={{ height: "100%" }}
                  >
                    <Box
                      sx={{
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        p: 3,
                        paddingBottom: "0px",
                        paddingTop: "0px",
                      }}
                    >
                      <img
                        src={resource.image}
                        alt={resource.title}
                        style={{
                          width: "100%",
                          height: "100%",
                          maxHeight: "250px",
                          objectFit: "contain",
                          borderRadius: "8px",
                        }}
                      />
                    </Box>
                  </motion.div>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                  <Box
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      p: 3,
                      paddingTop: "0px",
                    }}
                  >
                    <Typography
                      variant="h5"
                      gutterBottom
                      sx={{
                        fontWeight: "500",
                        color: "#00537E",
                      }}
                    >
                      {resource.title}
                    </Typography>
                    <Typography variant="body1" paragraph fontSize={"18px"}>
                      {resource.content}
                    </Typography>
                    {resource.actionText && (
                      <Typography
                        variant="h6"
                        sx={{
                          color: theme.palette.secondary.main,
                          fontWeight: "medium",
                        }}
                      >
                        {resource.actionText}
                      </Typography>
                    )}
                    {resource.link && (
                      <motion.div
                        whileHover={{ x: 5 }}
                        transition={{ duration: 0.2 }}
                      >
                        <Link
                          href={resource.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={{
                            mt: 1,
                            display: "inline-block",
                            color: theme.palette.primary.main,
                            "&:hover": {
                              textDecoration: "underline",
                            },
                          }}
                        >
                          Learn More →
                        </Link>
                      </motion.div>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </motion.div>
        ))}
      </Box>
    </Container>
  );
};

export default ResourcesPage;
